export { initialRealPrice, initialInstrument } from './initialInstrument';

export const multiplyProtectionReserveTo = 100;
export const defaultMaxValue = 999999999.99;

export const toFixedDefaultValue = 2;
